import React, { useState } from 'react'
import CourseCard from '../../components/cards/CourseCard'
import { WebCourses } from '../../providers/courses/CoursesProvider'

import './Animated-section.css';

const CourseCardSection = ({courses = []}) => {

    return (

        <div className="courses-section uk-child-width-1-3@m uk-child-width-1-2@s" uk-grid="">
            {courses.map(course => <CourseCard key={course.title} course={course} />)}
        </div>
    )
}

export default CourseCardSection
